// Real ENGELSKA KLAR™ sample pages (Volym 1), WebP hosted in Impultienda Recursos.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/1b2ecac8-2aca-46db-a73d-351022e4ff30/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [{
  src: BASE + '1792355588797_engelska-inuti-1-lektion-hello-82be7f1e.webp',
  label: 'Volym 1 · Lektion åk 1–3',
  title: 'Hello! Greetings – minut för minut',
  text: 'Mål, material, lärarmanus på svenska och nyckelfraser på engelska – hela lektionen planerad i 40 minuter.'
}, {
  src: BASE + '1792355594059_engelska-inuti-2-colour-by-number-14571c39.webp',
  label: 'Volym 1 · Arbetsblad åk 1–3',
  title: 'Colour by Number',
  text: 'Målarbild med engelska färgord och uppgifter i tre nivåer: Stöd, Bas och Utmaning.'
}, {
  src: BASE + '1792355599125_engelska-inuti-3-map-sunnyville-154ddb1f.webp',
  label: 'Volym 1 · Arbetsblad åk 4–6',
  title: 'Map of Sunnyville',
  text: 'Vägbeskrivningar och prepositioner – eleverna följer instruktionerna och ritar vägen på kartan.'
}, {
  src: BASE + '1792355603963_engelska-inuti-4-english-speaking-world-dc1c7df5.webp',
  label: 'Volym 1 · Lektion åk 7–9',
  title: 'The English-Speaking World',
  text: 'Länder, karta och fakta med minut-för-minut-plan och lärartips.'
}, {
  src: BASE + '1792355608617_engelska-inuti-5-klassrumsrutiner-a4482ea8.webp',
  label: 'Volym 1 · Affisch',
  title: 'Klassrumsrutiner på engelska',
  text: 'Start, övergångar och avslut – en affisch att skriva ut i A3 och sätta upp i klassrummet.'
}];
